import { render, staticRenderFns } from "./SellerCodeForm.vue?vue&type=template&id=0866428c"
import script from "./SellerCodeForm.vue?vue&type=script&lang=js"
export * from "./SellerCodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports